module.exports = __webpack_public_path__ + "img/hood length.feed8b13.png";